import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Tabs, Input, Table, Popconfirm } from 'antd';
import { ArrowLeftOutlined, SaveOutlined, DeleteOutlined, EditOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import TextFilter from '../components/TextFilter';

import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';

import Profile from '../components/settings/Profile';
import Social from '../components/settings/Social';
import Security from '../components/settings/Security';
import PaymentGateway from '../components/settings/PaymentGateway';
import About from '../components/settings/About';

function SettingAddEdit() {
	const navigate = useNavigate();
	const [editSettingId, setEditSettingId] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [form] = Form.useForm();

	const get = () => {
		axios
			.get(`/setting`, {})
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const [data] = result.data.data;
					if (data?.about?.delta) {
						data.about.delta = JSON.parse(data.about.delta);
					}
					// data.socials.forEach((social) => {
					// 	social.batchStartEndDateTime = [dayjs(batch.batchStartsAt), dayjs(batch.batchEndsAt)];
					// });
					const uplodedFileList = data?.media?.map((media) => ({
						uid: media._id,
						name: media.mediaTitle,
						status: 'done',
						url: media.mediaPath,
					}));
					if (Array.isArray(uplodedFileList)) {
						setFileList(uplodedFileList);
					}
					form.setFieldsValue(data);
					setEditSettingId(data._id);
				}
			})
			.catch(() => {})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				if (editSettingId) {
					values._id = editSettingId;
				}
				const media = [];
				fileList?.map(({ response }) => {
					if (response?.data?.length) {
						media.push(...response.data);
					}
					return response;
				});
				if (media.length) {
					values.media = media;
				}
				if (Array.isArray(values.socials)) {
					const socialMedias = [
						{
							mediaName: 'facebook',
							media: [
								{
									mediaPath: 'https://www.freepnglogos.com/uploads/logo-facebook-png/logo-facebook-facebook-logo-png-transparent-svg-vector-bie-supply-13.png',
									mediaType: 'IMAGE',
									mediaTitle: 'facebook.png',
								},
							],
						},
						{
							mediaName: 'instagram',
							media: [
								{
									mediaPath: 'https://www.freepnglogos.com/uploads/logo-facebook-png/logo-facebook-facebook-logo-png-transparent-svg-vector-bie-supply-13.png',
									mediaType: 'IMAGE',
									mediaTitle: 'instagram.png',
								},
							],
						},
						{
							mediaName: 'twitter',
							media: [
								{
									mediaPath: 'https://www.freepnglogos.com/uploads/logo-facebook-png/logo-facebook-facebook-logo-png-transparent-svg-vector-bie-supply-13.png',
									mediaType: 'IMAGE',
									mediaTitle: 'twitter.png',
								},
							],
						},
					];
					values.socials = values.socials.map((socialMedia) => {
						socialMedias.map(({ media, mediaName }) => {
							if (mediaName == socialMedia.socialName) {
								socialMedia.media = media;
							}
						});
						return socialMedia;
					});
					if (values?.about?.delta) {
						values.about.delta = JSON.stringify(values.about.delta);
					}
				}

				axios({
					method: editSettingId ? 'put' : 'post',
					url: '/setting',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/setting/add');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb
				breadcrumbs={[
					{
						link: '/',
						label: 'Home',
					},
					{
						label: 'Settings',
					},
				]}
			/>
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>Settings</div>
						<div className='page-title-more'>
							<Link to='/setting'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave}>
								Save
							</Button>
						</div>
					</div>
					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Tabs
								defaultActiveKey='1'
								items={[
									{
										key: 'Profile',
										label: 'Profile',

										children: <Profile Form={Form} getFieldValue={form.getFieldValue} setFieldValue={form.setFieldValue} fileList={fileList} setFileList={setFileList} />,
									},
									{
										key: 'Social',
										label: 'Social',
										children: <Social Form={Form} />,
									},
									// {
									// 	key: 'Security',
									// 	label: 'Security',
									// 	children: <Security Form={Form} />,
									// },
									{
										key: 'Payment Gateway',
										label: 'Payment Gateway',
										children: <PaymentGateway Form={Form} />,
									},
									{
										key: 'About',
										label: 'About',
										children: <About Form={Form} />,
									},
								]}
							/>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default SettingAddEdit;
